module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "150px"
    }
  }, [_c('form', {
    staticClass: "form-inline",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "1"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("导入正式车辆")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "6"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("导入测试车辆")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "2"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("设备更换")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "3"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("设备(整机)更换")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "4"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("SIM更换")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "5"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("设备导入模板")])], 1)])])]), _vm._v(" "), (_vm.type == 1) ? _c('dropzone', {
    attrs: {
      "id": "myVueDropzone1",
      "url": _vm.type1path,
      "headers": _vm.header,
      "maxFileSizeInMB": "6"
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('dropzone', {
    attrs: {
      "id": "myVueDropzone2",
      "url": _vm.type2path,
      "headers": _vm.header,
      "maxFileSizeInMB": "6"
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('dropzone', {
    attrs: {
      "id": "myVueDropzone3",
      "url": _vm.type3path,
      "headers": _vm.header,
      "maxFileSizeInMB": "6"
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 4) ? _c('dropzone', {
    attrs: {
      "id": "myVueDropzone4",
      "url": _vm.type4path,
      "headers": _vm.header,
      "maxFileSizeInMB": "6"
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 5) ? _c('dropzone', {
    attrs: {
      "id": "myVueDropzone5",
      "url": _vm.type5path,
      "headers": _vm.header,
      "maxFileSizeInMB": "6"
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 6) ? _c('dropzone', {
    attrs: {
      "id": "myVueDropzone6",
      "url": _vm.type6path,
      "headers": _vm.header,
      "maxFileSizeInMB": "6"
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1786a374","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FileUpload.vue
// module id = 1427
// module chunks = 0